import { errorCodeToMsg } from "./errorCodeToErrorMsg";
import { IError, ErrorTypes } from "../../interface/IShareInfo";

export const errorMessagesToString = (error: any) => {
  if (!error) return "Network error.";

  let errorMsg = "";

  if (error.response && error.response.data) {
    const { data } = error.response;
    if (typeof data === "string") {
      errorMsg = data;
    } else if (typeof data === "object") {
      const { message } = data;
      if (Array.isArray(data)) {
        data.forEach(ele => {
          const { code } = ele;
          if (code && errorCodeToMsg[code]) {
            errorMsg += `${errorCodeToMsg[code]}\n\t`;
          } else if (code === 409) {
            const { message } = ele;
            errorMsg += `${message}\n\t`;
          }
        });
      } else if (message) {
        errorMsg = message;
      }
    }
  } else {
    errorMsg = error.message;
  }

  return errorMsg || "Network error.";
};

export const errorMessagesToStringWithEmptyReturn = (error: any) => {
  if (!error) return "";

  let errorMsg = "";
  let code=200;
  if (error.response && error.response.data) {
    
    const { data } = error.response;
    if (typeof data === "string") {
      errorMsg = data;
    } else if (typeof data === "object") {

      const { message } = data;
      if (Array.isArray(data)) {
        data.forEach(ele => {
          const { code } = ele;
          if (code && errorCodeToMsg[code]) {
            errorMsg += `${errorCodeToMsg[code]}\n\t`;
          } else if (code === 409) {
            const { message } = ele;
            errorMsg += `${message}\n\t`;
          }
        });
      } else if (message) {
          code = data.code.toString();
          errorMsg = message;
        }
      }
  } else {
    errorMsg = error.message;
  }
        
  return {message: errorMsg || "", code: code};
};

export const commonErrorMessage = {
  type: ErrorTypes.NETWORK_ERROR,
  message: "Net work error, try again later"
} as IError;

export const errorResponseHandler = (
  error: any,
  defaultErrorMessage = commonErrorMessage
) => {
  const errorMessage = defaultErrorMessage;

  if (error.response && error.response.data && error.response.data.code) {
    errorMessage.type = `${error.response.data.code}` as ErrorTypes;
  }

  const messageResult = errorMessagesToStringWithEmptyReturn(error);
  if (messageResult) {
    errorMessage.message = messageResult.message;
    errorMessage.type  = messageResult.code as any;
  }

  return errorMessage;
};
